<!-- my-loader.component.html -->

<div class="loading-spinner" [hidden]="!loading">
    <!-- <img src="../../../assets/images/spinner.gif" /> -->
    <mat-spinner></mat-spinner>
    <span class="loading-message">Carregando...</span>
</div>